import api from './api';

const unwrap = (res, fallback) => {
  if (res && res.success === true) return { success: true, data: res.data };
  return { success: false, error: (res && (res.message || res.error)) || fallback };
};

const call = async (fn, fallback) => {
  try {
    return unwrap(await fn(), fallback);
  } catch (e) {
    return { success: false, error: e.message || fallback };
  }
};

const BASE = '/admin/insurance-enrollments';

class InsuranceEnrollmentService {
  list(params = {}) {
    return call(() => api.get(BASE, params), 'Failed to load enrollments');
  }

  stats(days) {
    return call(() => api.get(`${BASE}/stats`, { days }), 'Failed to load stats');
  }

  get(id) {
    return call(() => api.get(`${BASE}/${id}`), 'Failed to load enrollment');
  }

  revealSsn(id) {
    return call(() => api.post(`${BASE}/${id}/reveal`), 'Failed to reveal');
  }

  async file(id, kind) {
    try {
      const { data } = await api.getBlob(`${BASE}/${id}/files/${kind}`);
      return { success: true, data };
    } catch (e) {
      return { success: false, error: 'Failed to open file' };
    }
  }

  update(id, payload) {
    return call(() => api.patch(`${BASE}/${id}`, payload), 'Failed to update enrollment');
  }
}

const insuranceEnrollmentService = new InsuranceEnrollmentService();
export default insuranceEnrollmentService;
